import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import 'lib-flexible'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import './assetes/style/TimUi.css'
// import axios from 'axios'
import api from './api/api'
import util from './utils/util' // 导入工具类
import VueLazyLoad from 'vue-lazyload' // 加载后台图片
// import vueAplayer from 'vue-aplayer' // 音频文件
import VueAwesomeSwiper from 'vue-awesome-swiper' //轮播图
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui'//引入element-ui
import 'element-ui/lib/theme-chalk/index.css'


Vue.config.productionTip = false

Vue.prototype.$api = api
// 扩展一个工具类对象
Vue.prototype.$util = util

Vue.prototype.requestUrl = 'https://person.kequbang.com'
// Vue.prototype.requestUrl = 'http://192.168.2.12:8080'

Vue.use(Vant)
Vue.use(VueLazyLoad, {
  error: './img/logo.png', // 图片展示错误时加载的图片
  loading: './img/logo.png' // 图片加载中显示的图片
})
Vue.use(VueAwesomeSwiper) //轮播图
Vue.use(ElementUI) //eleement-ui
// Vue.use(vueAplayer)
new Vue({
  router,
  store,
  data: function () {
    return {
      userInfo: null,
      isLogin: false
    }
  },
  render: h => h(App)
}).$mount('#app')
